export default __webpack_public_path__ + "static/media/not-found.a2d326ac.svg";